import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "timeout", "children", "tag", "show", "speed", "mountOnEnter"];
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import CSSTransition from "../CSSTransiton";

var Fade = function Fade(_ref) {
  var className = _ref.className,
      timeout = _ref.timeout,
      children = _ref.children,
      Tag = _ref.tag,
      show = _ref.show,
      speed = _ref.speed,
      mountOnEnter = _ref.mountOnEnter,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(CSSTransition, {
    show: !!show,
    animation: "css-transition-fade-".concat(speed),
    className: cn(!show ? 'opacity-0' : '', 'css-transition-fade', className),
    timeout: timeout,
    unmountOnExit: mountOnEnter,
    mountOnEnter: mountOnEnter,
    "data-qa": "fade"
  }, /*#__PURE__*/React.createElement(Tag, rest, children));
};

Fade.defaultProps = {
  className: '',
  tag: 'span',
  speed: 'reg',
  children: null,
  timeout: 225,
  mountOnEnter: false
};
Fade.propTypes = {
  /** Bool whether or not to show (fade in) children */
  show: PropTypes.bool,

  /** Additional class for root level */
  className: PropTypes.string,

  /** children to render for the fade component */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),

  /** Timeout for fade animation */
  timeout: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.number.isRequired,
    exit: PropTypes.number.isRequired
  }), PropTypes.number]),

  /** Tag to render for fade */
  tag: PropTypes.string,

  /** Custom fade speed */
  speed: PropTypes.oneOf(['quick', 'reg', 'slow']),

  /** Mount and unmount on show/hide (true) or keep mounted -default */
  mountOnEnter: PropTypes.bool
};
export default Fade;